import { useState } from "react";
import Bens from "./Bens";
import Planos from "./Planos";
import Results from "./Results";
import PersonalData from "./PersonalData";
import Layout from "../Layout";
import { segments } from "../../config/constants";
import { useParams } from "react-router-dom";
import styles from "./styles.module.css";
import { useNavigate } from "react-router-dom";
import HorizontalStepper from "../../components/Stepper";

function Form(props) {
  const { segmento } = useParams();
  const bens = segments[segmento].data || [];
  const navigate = useNavigate();

  const [data, setData] = useState({
    segmento,
    credito: {},
    plano: {
      amortizacao: {},
      custoTotal: {},
      fundoReserva: {},
      grupo: {},
      menorLanceContemplacao: {},
      seguro: {},
      taxaAdministracao: {},
    },
    personal: {
      name: "",
      cpf: "",
      email: "",
      celular: "",
    },
  });
  const dataManager = { data, setData };
  const [step, setStep] = useState(0);

  const nextStep = () => {
    if (step + 1 <= 3) {
      setStep((step) => step + 1);
    } else setStep(0);
  };

  const goBack = () => {
    if (step > 0) {
      setStep((step) => step - 1);
    } else setStep(0);
  };

  function renderSwitch() {
    switch (step) {
      case 0:
        return (
          <Bens
            bens={bens}
            dataManager={dataManager}
            onNext={nextStep}
            onBack={() => navigate("/")}
          />
        );
      case 1:
        return (
          <Planos dataManager={dataManager} onNext={nextStep} onBack={goBack} />
        );
      case 2:
        return (
          <PersonalData
            dataManager={dataManager}
            onNext={nextStep}
            onBack={goBack}
          />
        );
      case 3:
        return (
          <Results
            dataManager={dataManager}
            onNext={nextStep}
            onBack={goBack}
          />
        );
      default:
        return <div>Not Found</div>;
    }
  }

  return (
    <Layout>
      <div>
        <h6>Simulação</h6>
        <div className={styles.titleBox}>
          <h1>Consórcio de</h1>
          <h1 className={styles.text}>{segments[segmento]?.title}</h1>
        </div>
      </div>
      <div className={`${styles.stepper} fromStep`}>
        <HorizontalStepper
          steps={[
            { title: "Bem" },
            { title: "Plano" },
            { title: "Dados" },
            { title: "Resultado" },
          ]}
          activeStep={step}
        />
      </div>
      <div {...props}>{renderSwitch()}</div>
    </Layout>
  );
}

export default Form;
